import { TextField } from "@mui/material";
import styled from "styled-components";

export const ReportDumpingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  @media (min-width: 428px) {
    padding: 0;
    align-items: center;
  }
`;

export const ReportDumpingFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 10px;
  gap: 40px;

  @media (min-width: 428px) {
    padding: 40px 0px;
  }

  @media (min-width: 1440px) {
    flex-direction: row;
  }
`;

export const ReportDumpingRightFormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;

  @media (min-width: 1440px) {
    width: 550px;
  }
`;
export const ReportDumpingTextField = styled(TextField)`
  width: 100%;

  @media (min-width: 428px) {
    width: 398px;
  }

  @media (min-width: 744px) {
    width: 550px;
  }

  @media (min-width: 1440px) {
    width: 550px;
  }
`;

export const ReportDumpingSendButtonWrapper = styled.div`
  padding: 0 15px;

  @media (min-width: 744px) {
    padding: 0;
  }
`;

export const ReportDumpingSendButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #079ff4;
  border-radius: 40px;
  font-weight: 500;
  font-size: 24px;
  height: 65px;
  width: 100%;
  color: #ffffff;
  margin-bottom: 60px;

  @media (min-width: 428px) {
    height: 65px;
    width: 398px;
  }

  @media (min-width: 744px) {
    height: 65px;
    width: 380px;
  }
`;
